const UserIcon = ({ className }: { className: string }) => (
  <svg
    aria-hidden='true'
    width='70'
    height='70'
    viewBox='0 0 70 70'
    fill='none'
    className={className}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M35.0546 37.953C20.3757 37.953 8.47656 49.8521 8.47656 64.5312H61.6327C61.6327 49.8521 49.7333 37.953 35.0546 37.953ZM20.2891 20.2343C20.2891 12.0796 26.8997 5.46875 35.0546 5.46875C43.2094 5.46875 49.8202 12.0796 49.8202 20.2343C49.8202 28.3891 43.2094 34.9999 35.0546 34.9999C26.8997 34.9999 20.2891 28.3891 20.2891 20.2343Z'
      fill='currentColor'
    />
  </svg>
);

export default UserIcon;
